import type { Glyph } from "./types";

export const CrossIcon: Glyph = (props) => (
  <svg viewBox="0 0 12 12" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M0.146 0.854C-0.049 0.658 -0.049 0.342 0.146 0.146C0.342 -0.049 0.658 -0.049 0.854 0.146L6 5.293L11.146 0.146C11.342 -0.049 11.658 -0.049 11.854 0.146C12.049 0.342 12.049 0.658 11.854 0.854L6.707 6L11.854 11.146C12.049 11.342 12.049 11.658 11.854 11.854C11.658 12.049 11.342 12.049 11.146 11.854L6 6.707L0.854 11.854C0.658 12.049 0.342 12.049 0.146 11.854C-0.049 11.658 -0.049 11.342 0.146 11.146L5.293 6L0.146 0.854Z" />
  </svg>
);

export default CrossIcon;
